<template>
  <div class="create_wrapper fadeIn">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between product">
            <div class="row justify-content-center">
              <!-- ********** Row Data ********** -->
              <div class="upload_input_wrapper me-auto col-7">
                <div>
                  <uplode-image
                    @inputChanged="uplodeClientImg"
                    placeHolder="صورة العميل "
                  ></uplode-image>
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isArabic"
                    v-model.trim="data.alt_image_ar"
                  />
                  <label for="name_input" class="form-label"
                    >النص البديل للصورة (عربي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isEnglish"
                    v-model.trim="data.alt_image_en"
                  />
                  <label for="name_input" class="form-label"
                    >النص البديل للصورة (إنجليزي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isArabic"
                    v-model.trim="data.ar.name"
                  />
                  <label for="name_input" class="form-label"
                    >الاسم (عربي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isEnglish"
                    v-model.trim="data.en.name"
                  />
                  <label for="name_input" class="form-label"
                    >الاسم (إنجليزي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isArabic"
                    v-model.trim="data.ar.title"
                  />
                  <label for="name_input" class="form-label"
                    >الوظيفة (عربي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    @keypress="isEnglish"
                    v-model.trim="data.en.title"
                  />
                  <label for="name_input" class="form-label"
                    >الوظيفة (إنجليزي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <label for="textarea_1" class="form-label">
                    ماذا قال عنا (عربي)</label
                  >
                  <textarea
                    class="form-control"
                    rows="5"
                    @keypress="isArabic"
                    v-model="data.ar.desc"
                  ></textarea>
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <label for="textarea_1" class="form-label">
                    ماذا قال عنا (إنجليزي)</label
                  >
                  <textarea
                    class="form-control"
                    rows="5"
                    @keypress="isEnglish"
                    v-model="data.en.desc"
                  ></textarea>
                </div>
              </div>

              <div class="col-lg-6 py-0">
                <div class="input_wrapper">
                  <label for="name_input" class="form-label">
                    المشروع
                  </label>
                  <multiselect
                    v-model="data.project"
                    :options="projects"
                    label="name"
                    track-by="id"
                    placeholder=" "
                    :searchable="true"
                    :allow-empty="true"
                    :show-labels="false"
                  >
                    <template slot="option" slot-scope="props">
                      <img class="option__image" :src="props.option.image" />
                      <div class="option__desc d-flex justify-between">
                        <span class="option__title">
                          {{ props.option.name }}
                        </span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="buttons_wrapper">
            <button class="base-btn">
              {{ $t("forms.submit") }}
              <span class="btn_loader" v-if="btnIsLoading"></span>
            </button>
          </div>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.reviews.title"),
          disabled: false,
          href: "/reviews/show-all",
        },
        {
          text: this.$t("breadcrumb.reviews.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        image: null,
        project: null,
        alt_image_ar: null,
        alt_image_en: null,
        en: {
          name: null,
          title: null,
          desc: null,
        },
        ar: {
          name: null,
          title: null,
          desc: null,
        },
      },
      is_active: true,
      projects: [
        {
          id: 42,
          name: "Outfit",
          image: "",
        },
        {
          id: 55,
          name: "davina",
          image: "",
        },
      ],
    };
  },
  computed: {},

  methods: {
    // Uplode Client Image
    uplodeClientImg(obj) {
      this.data.image = obj;
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل اسم العميل بالعربي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل اسم العميل بالانجليزي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل الوظيفة بالعربي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أدخل الوظيفة بالانجليزي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: " أدخل رأي العميل بالعربي ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: " أدخل رأي العميل بالانجليزي ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.project) {
        this.$iziToast.error({
          timeout: 2000,
          message: " أختر مشروع ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ارفق صورة للعميل ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();

        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("project_id", this.data.project.id);
      submit_data.append("ar[client_name]", this.data.ar.name);
      submit_data.append("ar[career]", this.data.ar.title);
      submit_data.append("ar[content]", this.data.ar.desc);
      submit_data.append("en[client_name]", this.data.en.name);
      submit_data.append("en[career]", this.data.en.title);
      submit_data.append("en[content]", this.data.en.desc);
      if (this.data.alt_image_ar) {
        submit_data.append(`ar[alt_image]`, this.data.alt_image_ar);
      }
      if (this.data.alt_image_en) {
        submit_data.append(`en[alt_image]`, this.data.alt_image_en);
      }
      submit_data.append("client_image", this.data.image.img_file);

      this.axios({
        method: "POST",
        url: "review",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("addSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/reviews/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    // ====== Main Categories
    getProjects() {
      this.axios({
        method: "GET",
        url: `project_without_pagination`,
      })
        .then((res) => {
          this.projects = res.data.data;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  mounted() {
    this.getProjects();
  },
};
</script>

<style lang="scss" scoped>
.product {
  .chooseImage {
    width: auto !important;
  }
}
.repeater_wrapper {
  border: 1px solid #29398c;
  border-radius: 15px;
  padding-block: 20px;

  h3,
  h5 {
    color: #29398c;
  }

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
.productDetails {
  border: 1px solid #339989;
  border-radius: 15px;
  padding-block: 20px;

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
